import {useState} from 'react'
import PropTypes from 'prop-types'
import {CircularProgress} from '@mui/material'
import {
  StyledTypographyForText,
  StyledTypographyForValue,
  StyledDiv,
  StyledIconButton,
  StyledInfoOutlinedIcon,
  TooltipBody,
  TooltipHeading,
  StyledUSPercentageTypography
} from './SingleDataViewerStyle'
import {StyledTooltip} from '../../BreadCrumb/BreadCrumbStyle'

const SingleDataViewerComponent = ({value, text, loading, icon, percent}) => {
  const tooltipHeading = 'Unique Addresses'
  const tooltipBody = 'Estimate based on a combination of raw data and predictive models'
  const title = 'Loading ' + text
  const ariaLabel = `${text}, ${value}`
  const [isUniqueAddressToolTipOpen, setIsUniqueAddressToolTipOpen] = useState(false)
  const handleUniqueAddressClickAway = () => {
    setIsUniqueAddressToolTipOpen(false)
  }

  const isUSPopulationCard = text.includes('US')
  return (
    <StyledDiv tabIndex={0} aria-label={ariaLabel} className={isUSPopulationCard ? 'no-left-margin' : ''}>
      <StyledTypographyForText variant='labelMedium'>
        {text}
        {icon && (
          <StyledTooltip
            title={
              <div>
                <TooltipHeading>{tooltipHeading}</TooltipHeading>
                <TooltipBody>{tooltipBody}</TooltipBody>
              </div>
            }
            enterTouchDelay={0}
            open={isUniqueAddressToolTipOpen}
            onClickAway={handleUniqueAddressClickAway}
            disableHoverListener={true}
            disableFocusListener={true}
            aria-describedby='unique-address-tooltip'
          >
            <StyledIconButton
              onClick={() => setIsUniqueAddressToolTipOpen(!isUniqueAddressToolTipOpen)}
              id='unique-address-tooltip'
              aria-label={
                isUniqueAddressToolTipOpen ? `${tooltipHeading} ${tooltipBody}` : 'Toggle Unique Address tooltip'
              }
              aria-controls='unique-address-tooltip'
              aria-expanded={isUniqueAddressToolTipOpen}
            >
              <StyledInfoOutlinedIcon />
            </StyledIconButton>
          </StyledTooltip>
        )}
      </StyledTypographyForText>
      <StyledTypographyForValue variant='kpiMedium'>
        {!loading && (
          <>
            {value}
            {percent && <StyledUSPercentageTypography>{`${percent}% of US`}</StyledUSPercentageTypography>}
          </>
        )}
        {loading && <CircularProgress size={25} title={title} />}
      </StyledTypographyForValue>
    </StyledDiv>
  )
}

SingleDataViewerComponent.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  loading: PropTypes.bool,
  icon: PropTypes.bool,
  percent: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
}

export default SingleDataViewerComponent
